import React from "react";
import EditBtn from "../../../UI/Button/EditBtn";
import { useMediaQuery } from "@mui/material";

function TextField({ value, onChange }) {
  return (
    <div className="w-full h-full">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-10 border border-[#B3B3B3] bg-white rounded-[10px] !outline-none text-custom-size py-2.5 px-3"
      />
    </div>
  );
}

function CustomerTableRow({ rowData, onClickEdit, handleChange }) {
  const isMd = useMediaQuery("(min-width:768px)");

  if (!rowData.hidden) {
    return <div className="w-full flex relative">
      <div
        className="border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] px-0 py-[10px] text-sm flex items-center"
        style={{
          width: "25%",
          textAlign: rowData.textAlign || "start",
        }}
      >
        <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
          {rowData.title}
          {rowData.isRequired && (
            <span style={{color: "red"}}>*</span>
          )}
        </p>
      </div>

      {rowData.CustomTableCell ? (
        <rowData.CustomTableCell
          rowData={rowData}
          handleChange={handleChange}
        />
      ) : (
        <>
          {rowData.showInput ? (
            <div className="w-[75%] h-full">
              <TextField
                InputProps={{
                  style: {
                    borderRadius: "10px",
                  },
                }}
                value={rowData.detail}
                onChange={(newValue) =>
                  handleChange(rowData.dataKey, newValue)
                }
                size="small"
              />
            </div>
          ) : (
            <div
              className="h-full w-[75%] border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] px-0 py-[10px] text-sm"
              style={{
                flex: 1,
                textAlign: rowData.textAlign || "start",
              }}
            >
              <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
                {rowData.detail || "-"}
              </p>
            </div>
          )}
        </>
      )}

      {rowData.shouldEdit && (
        <EditBtn
          width="3%"
          style={{
            justifyContent: "center",
            position: "absolute",
            right: isMd ? "-30px" : "-15px",
            height: "100%",
            alignItems: "center",
          }}
          onClick={() => onClickEdit(rowData.dataKey)}
          showInput={rowData.showInput}
        />
      )}
    </div>
  } else {
    return <></>
  }
}

export default CustomerTableRow;
